import ProductModel from '@/models/paymentportal/product-model'

export default class ShoppingCartModel {
  products: ProductModel[] = []

  price = 0.0
}
